<div
  class="error-overlay"
  *ngIf="show"
>
  <div
    class="error_sunedu"
    role="status"
  >
    <span>
      <h5 style="width:80%; margin:50px auto;">
      El contenido al que deseas acceder no se encuentra disponible en este momento. Estamos trabajando para solucionarlo, disculpe las molestias.
      </h5>

      <button class="btn btn-info btn-sm" style="margin-bottom:10px;"onclick="JavaScript: location.reload(true);">
        &nbsp;&nbsp;Volver a consultar&nbsp;&nbsp;
      </button>
      <br>

    </span>
  </div>
</div>
